import vm from '~/main'

export default {
  $roundNumberToTenths: (number) => {
    return Math.floor(number * 10) / 10
  },
  $clientProjectNumber: ({project_id, year, segment_letter, project_number}) => {
    if (vm.$store.state.companiesConfig && vm.$store.state.companiesConfig.short_name) {
      if (project_id) {
        let result = '#' + vm.$store.state.companiesConfig.short_name
        if (project_number) {
          result += project_number
        } else {
          if (year) {
            result = result + year.toString()
          } else {
            result = result + '21'
          }
          if (project_id) {
            let idString = project_id.toString()
            if (idString.length == 1) {
              result = result + '000' + idString
            } else if (idString.length == 2) {
              result = result + '00' + idString
            } else if (idString.length == 3) {
              result = result + '0' + idString
            } else if (idString.length == 4) {
              result = result + idString
            }
          }
          if (segment_letter) {
            result = result + segment_letter.capitalize()
          }
        }
        return result
      } else {
        return '#' + vm.$store.state.companiesConfig.short_name
      }
    } else return '#'
  },
  $css: (element, style) => {
    for (const property in style) element.style[property] = style[property]
  },
  $GetDaysByProjectsFinanceSalary: (data, checkbox) => {
    let result = {}
    for (let p in data) {
      let project = data[p]
      let workList = {
        work_types: project.work_types,
        extras: project.extras,
        responsible: project.responsible
      }
      for (let type in workList) {
        for (let workKey in workList[type]) {
          let work = workList[type][workKey]
          for (let dayKey in work.days) {
            let date = dayKey.split('-')
            if (work.days[dayKey].reports) {
              const project_responsible_salary = work.days[dayKey].reports.reduce((accumulator, item) => {
                accumulator = accumulator + item.project_responsible_salary
                return accumulator
              }, 0)
              const project_responsible_salary_sum = work.days[dayKey].reports.reduce((accumulator, item) => {
                accumulator = accumulator + item.project_responsible_salary_sum
                return accumulator
              }, 0)
              const project_responsible_name = work?.days[dayKey]?.reports[0]?.responsible_user_id ? work?.days[dayKey]?.reports[0]?.responsible_user_first_name + ' ' + work?.days[dayKey]?.reports[0]?.responsible_user_last_name : '—'
              let temp = {
                name: work.name,
                measure: work.measure,
                is_hourly: work.is_hourly,
                reports: work.days[dayKey].reports,
                project_id: data[p].id,
                project_name: data[p].name,
                salary: work.salary,
                salary_sum: work.salary_sum,
                project_responsible_salary: project_responsible_salary,
                project_responsible_salary_sum: project_responsible_salary_sum,
                project_responsible_name: project_responsible_name,
              }
              if (result[dayKey]) {
                if (!result[dayKey]['projects'][p])
                  result[dayKey]['projects'][p] = {name: data[p].name}
                if (!result[dayKey]['projects'][p][type]) result[dayKey]['projects'][p][type] = {}
              } else {
                result[dayKey] = {projects: {}}
                result[dayKey]['projects'][p] = {name: data[p].name}
                result[dayKey]['projects'][p][type] = {}
              }
              result[dayKey].date = date[2] + '/' + date[1]
              result[dayKey]['projects'][p][type][workKey] = temp
              // get value for checkbox from all extras by one day
              if (checkbox && result[dayKey]['projects'][p].extras) {
                let reports = []
                let extras = Object.values(result[dayKey]['projects'][p].extras).map((e) => e.reports,)
                for (let e in extras) reports = reports.concat(extras[e])
                reports = reports.map((e) => e['paid_report'])
                result[dayKey]['projects'][p]['extras_paid'] = reports.every((e) => {
                  return Number(e) > 0
                })
                  ? true
                  : reports.every((e) => {
                    return Number(e) === 0
                  })
                    ? false
                    : null
              }
            }
          }
        }
      }
    }
    result = Object.keys(result)
      .sort()
      .reduce((accumulator, key) => {
        accumulator[key] = result[key]
        return accumulator
      }, {})
    return result
  },
  $formatCurrency: (num) => {
    num = Number(num)
    let integer = Math.trunc(num)
    let fraction = String(Math.round((num - integer) * 100)).padStart(2, '0')
    integer = String(integer).split('').reverse()
    let result = ''
    for (let i in integer) {
      if (i != 0 && i % 3 === 0) result = ' ' + result
      result = integer[i] + result
    }
    return result + ',' + fraction
  }
}
